var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"signup"},[_c('SignUpHero'),_c('SignUpContainer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }